import { Extension } from '@tiptap/core';
import * as typingBuffer from '../utils/typingBufferSingleton';
import { defer } from 'lodash';

interface TypingBufferStorage {
    hasProcessedBuffer: boolean;
}

// Helper function outside the extension to handle the buffer processing logic
function processBuffer(editor: any, storage: TypingBufferStorage): void {
    // Prevent multiple insertions
    if (storage.hasProcessedBuffer) return;

    const chars = typingBuffer.consume();
    if (!chars) return;

    storage.hasProcessedBuffer = true;

    // Use defer to ensure the editor is fully ready
    defer(() => {
        try {
            editor.commands.insertContent(chars);
            editor.commands.focus('end');
        } catch (error) {
            console.error('Failed to insert typing buffer content:', error);
        }
    });
}
/**
 * Extension to put the typing buffer's content into the editor when it receives focus or is created.
 */
export const TypingBuffer = Extension.create<{}, TypingBufferStorage>({
    name: 'typingBuffer',

    addStorage(): TypingBufferStorage {
        return {
            hasProcessedBuffer: false,
        };
    },

    onCreate(): void {
        processBuffer(this.editor, this.storage);
    },

    onFocus(): void {
        processBuffer(this.editor, this.storage);
    },

    onDestroy(): void {
        typingBuffer.clear();
        this.storage.hasProcessedBuffer = false;
    },
});
